import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

// SECTION: AUTH THUNKS

// NOTE: Validating the generated authenticaion token for password reset
export const validateToken = createAsyncThunk(
  "auth/validate/token",
  async ({ id, token }) => {
    const response = await api.get(`auth/verify-forgot/user/${id}/${token}`);
    return response.data;
  }
);

// NOTE: Resetting the password
export const updatePassword = createAsyncThunk(
  "auth/update/password",
  async ({ id, token, data }) => {
    const response = await api.post(
      `auth/change-password/user/${id}/${token}`,
      data
    );
    return response.data;
  }
);

//! NOTE: Onboarding Signup
export const onboardingSignup = createAsyncThunk(
  "auth/onboardingSignup",
  async (data, { rejectWithValue }) => {
    try {
      console.log("data: ", data);
      const response = await api.post("auth/onboarding/user", data); //! Fixed backend endpoint
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "Onboarding signup failed" });
    }
  }
);

//! NOTE: Validate Referral Code
export const validateReferral = createAsyncThunk(
  "auth/validateReferral",
  async (code, { rejectWithValue }) => {
    try {
      const response = await api.get(`auth/referral/${code}`); //! Adjusted endpoint to match backend
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "Referral validation failed" });
    }
  }
);

//! NOTE: Signin
export const signin = createAsyncThunk(
  "auth/signin/user",
  async (data) => {
    const response = await api.post("auth/signin/user", data);
    return response.data; // { userData, token }
  }
);

//! NOTE: Check user approval status
export const checkUserStatus = createAsyncThunk(
  "auth/checkUserStatus",
  async (userId) => {
    try {
      const response = await api.get(`auth/check-status/${userId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

//! NOTE: Forgot Password
export const forgotPassword = createAsyncThunk(
  "auth/forgot-password",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post("auth/forgot-password/user", data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Forgot password failed" }
      );
    }
  }
);


//! NOTE: Reset password
export const resetPassword = createAsyncThunk(
  "auth/reset-password",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post("auth/reset-password/user", data); 
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Reset password failed" }
      );
    }
  }
);
